export default __webpack_public_path__ + "static/media/Settings_TabSize.467b4ce9.svg";